import React from "react"
import { graphql } from "gatsby"

import AlternatingList from "./alternatingList"
import EventTitle from "./eventTitle"
import Link from "./link"
import SpeakerCard from "./speakerCard"
import Image from "./image"
import Snippet from "./snippet";

import style from "./alternatingList.module.css"

const EventList = ({ type, meta, snippetId, events, extra, extras }) => (
	<AlternatingList type={type} meta={meta} snippetId={snippetId}>
		{generateEvents(events, extras ? extras : extra ? [ extra ] : [])}
	</AlternatingList>
)

function generateEvents(events, extras) {
	if (!events || events.length === 0) return <span />
	return (
		<React.Fragment>
			{events.map(({ node }) => generateEvent(node))}
			{extras.map(extra => generateExtra(extra))}
		</React.Fragment>
	)
}

function generateExtra(extra) {
	return (
		<div className={style.container}>
			<div className={style.image}><Image size="small" slug={extra.imageSlug} /></div>
			<div className={style.event}>
				<h2 className={style.title}>
					<EventTitle event={{ frontmatter: { title: extra.title } }} />
				</h2>
				{ extra.snippetId && <Snippet id={extra.snippetId} /> }
				{ extra.html && <p className={style.teaser} dangerouslySetInnerHTML={{ __html: extra.html }} />}
			</div>
		</div>
	)
}

function generateEvent(event) {
	return (
		<div className={style.container}>
			<div className={style.speakers}>{images(event.frontmatter.speakers)}</div>
			<div className={style.event}>
				<h2 className={style.title}>
					<EventTitle event={event} linkTitle />
				</h2>
				<p className={style.teaser}>
					{event.frontmatter.excerpt} <Link to={event.fields.path}>More...</Link>
				{event.frontmatter.slides && (
					<>
						{event.frontmatter.slides.url && <> / <Link to={event.frontmatter.slides.url}>Slides</Link></>}
						{event.frontmatter.slides.pdf && <> / <a href={`/slides/${event.frontmatter.slides.pdf}`}>Slides (PDF)</a></>}
					</>
				)}
				</p>
			</div>
		</div>
	)
}

function images(speakers) {
	if (!speakers || speakers.length === 0) return

	return speakers.map(speaker => (
		<SpeakerCard
			speakerSlug={speaker.frontmatter.slug}
			size="small"
			linkImage
			showName
			linkName
			className={style.image}
		/>
	))
}

export const query = graphql`
	fragment AllEventEdges on MarkdownRemarkConnection {
		edges {
			node {
				fields {
					path
				}
				frontmatter {
					title
					excerpt
					language
					slides {
						url
						pdf
					}
					speakers {
						fields {
							path
						}
						frontmatter {
							slug
						}
					}
				}
			}
		}
	}
`

export default EventList
